import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { hasSession } from "./lib/client.js";
import { Shell } from "./components/Shell.tsx";
import { LoginPage } from "./pages/Login.tsx";
import { DashboardPage } from "./pages/Dashboard.tsx";
import { AppDetailPage } from "./pages/AppDetail.tsx";
import { StorePage } from "./pages/Store.tsx";
import { JobDetailPage } from "./pages/JobDetail.tsx";
import { JobsPage } from "./pages/Jobs.tsx";
import { ModerationPage } from "./pages/Moderation.tsx";
import { NotificationsPage } from "./pages/Notifications.tsx";
import { FlagsPage } from "./pages/Flags.tsx";
import { StreamFailuresPage } from "./pages/StreamFailures.tsx";
import { StationReportsPage } from "./pages/StationReports.tsx";
import { StationSubmissionsPage } from "./pages/StationSubmissions.tsx";
import { StationsPage } from "./pages/Stations.tsx";
import { StationDuplicatesPage } from "./pages/StationDuplicates.tsx";
import { AnalyticsPage } from "./pages/Analytics.tsx";
import { SecurityPage } from "./pages/Security.tsx";
import { BotPage } from "./pages/Bot.tsx";
import { OpsPage } from "./pages/Ops.tsx";
import { FeedbackPage } from "./pages/Feedback.tsx";

export function App(): ReactNode {
  if (!hasSession()) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/apps/:appId" element={<AppDetailPage />} />
        <Route path="/apps/:appId/store" element={<StorePage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:jobId" element={<JobDetailPage />} />
        <Route path="/moderation" element={<ModerationPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/flags" element={<FlagsPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/stream-failures" element={<StreamFailuresPage />} />
        <Route path="/station-reports" element={<StationReportsPage />} />
        <Route path="/stations" element={<StationsPage />} />
        <Route path="/station-duplicates" element={<StationDuplicatesPage />} />
        <Route path="/station-submissions" element={<StationSubmissionsPage />} />
        <Route path="/bot" element={<BotPage />} />
        <Route path="/ops" element={<OpsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
